module.exports = __webpack_public_path__ + "img/bgc6.1e519eaa.png";